import { Modalable, ResponseStatus } from './modalable';

export class ModalableAccessCode implements Modalable {
    static MODAL_ID = 'accessCodeModal';
    bypass = true;

    getModalId(): string {
        return ModalableAccessCode.MODAL_ID;
    }

    canBypassCheck(): boolean {
        return this.bypass;
    }

    getStatus(): ResponseStatus {
        return undefined;
    }
}
